// removed by extract-text-webpack-plugin
module.exports = {"Header":"Header__Header__oE2FH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Header.css
// module id = 103
// module chunks = 0